import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FormInput } from '../../../components/form-input';
import { useForm, Controller } from 'react-hook-form';

interface ChangePasswordDialogProps {
  onSubmit: (newPassword: string, oldPassword: string) => void;
  onClose: () => void;
  open: boolean;
  username: string;
}

interface FormFields {
  oldPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

export function ChangePasswordDialog(props: ChangePasswordDialogProps) {
  const { onSubmit, open, onClose, username } = props;

  const { control, handleSubmit, getValues } = useForm<FormFields>({
    defaultValues: { oldPassword: '', newPassword: '', confirmPassword: '' },
  });

  const onFormSubmit = (data: FormFields) => {
    if (data.oldPassword && data.newPassword) {
      onSubmit(data.newPassword, data.oldPassword);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>Zmena hesla</DialogTitle>

      <DialogContent>
        <form>
          <input type="email" hidden id="username" name="username" autoComplete="username" value={username} />
          <Controller
            name="oldPassword"
            control={control}
            render={({ field, fieldState }) => (
              <FormInput
                autoFocus
                required
                autoComplete="current-password"
                type="password"
                label="Pôvodné heslo"
                value={field.value ?? ''}
                onChange={field.onChange}
                errorText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="newPassword"
            control={control}
            render={({ field, fieldState }) => (
              <FormInput
                autoComplete="new-password"
                type="password"
                label="Nové heslo"
                value={field.value ?? ''}
                onChange={field.onChange}
                required
                errorText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              validate: (value) => value === getValues('newPassword') || 'Heslá sa nezhodujú.',
            }}
            render={({ field, fieldState }) => (
              <FormInput
                type="password"
                autoComplete="new-password"
                label="Potvrdenie nového hesla"
                value={field.value ?? ''}
                onChange={field.onChange}
                required
                errorText={fieldState.error?.message}
              />
            )}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zatvoriť</Button>
        <Button type="submit" variant="contained" onClick={handleSubmit(onFormSubmit)}>
          Uložiť
        </Button>
      </DialogActions>
    </Dialog>
  );
}
